import { useEffect, useRef } from "react";
import db from "../../dexieDB";

export const useDexieSync = (tableName, data, setData) => {
  const hasMounted = useRef(false);
  // Sync data to Dexie on change
  useEffect(() => {
    const syncToDexie = async () => {
      if (!hasMounted.current) {
        hasMounted.current = true;
        return;
      }
      if (!db[tableName]) {
        console.warn(`Dexie table "${tableName}" does not exist.`);
        return;
      }

      try {
        const allKeys = await db[tableName].toCollection().primaryKeys();
        await db[tableName].bulkDelete(allKeys);

        if (Array.isArray(data) && data.length > 0) {
          await db[tableName].bulkPut(data);
        }
      } catch (err) {
        console.error("Failed to sync to Dexie:", err);
      }
    };
    if (Array.isArray(data) && data.length > 0) {
      syncToDexie();
    }
    // eslint-disable-next-line
  }, [tableName, data]);

  // Load data from Dexie on mount
  useEffect(() => {
    const fetchFromDexie = async () => {
      if (!db[tableName]) {
        console.warn(`Dexie table "${tableName}" does not exist.`);
        return;
      }

      const stored = await db[tableName].toArray();
      if (stored.length === 0) {
        if (!hasMounted.current) {
          hasMounted.current = true;
        }
      }
      setData(stored);
    };

    fetchFromDexie();
    // eslint-disable-next-line
  }, []);
};
